import * as React from "react";
import classNames from "classnames";

interface IFavouritesToggle {
    cssWrapper?: string;
    label: string | JSX.Element;
    labelSrOnly?: boolean;
    isFavourite?: boolean;
    // isIcon?: boolean;
    onToggle?: (v) => void;
}

export const FavouritesToggle = (props: IFavouritesToggle) => {
    const selectToggle = (e) => {
        e.preventDefault();
        // if (props.isIcon) return;
        if (props.onToggle) {props.onToggle(!props.isFavourite);}
    };

    const cssClassNames = classNames("favourites-toggle", props.cssWrapper);

    return (
        <button
            className={cssClassNames}
            title="Favourites"
            onClick={(e) => {
                selectToggle(e);
            }}
            aria-pressed={props.isFavourite}
        >
            <span aria-hidden="true" className="icon"></span>
            <a className="label hyperlink">{props.label}</a>
        </button>
    );
};
